module.exports = __webpack_public_path__ + "img/format_align_right.34b56cf8.svg";